import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoginGuestUseCase } from '@/core/domain/user/usecases/loginGuest.usecase';
import { UserImplRepository } from './user-imp.respository';
import { UserRepository } from '@/core/domain/user/repositories/user.respository';
import { GetUserUseCase } from '@/core/domain/user/usecases/getUser.usecase copy';
import { LoginUserUseCase } from '@/core/domain/user/usecases/loginUser.usecase';

const loginGuestUseCaseFactory = (repository: UserRepository) =>
    new LoginGuestUseCase(repository);

const getUserUseCaseFactory = (repository: UserRepository) =>
    new GetUserUseCase(repository);

const loginUserUseCaseFactory = (repository: UserRepository) =>
    new LoginUserUseCase(repository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: LoginUserUseCase,
            useFactory: loginUserUseCaseFactory,
            deps: [UserImplRepository],
        },
        {
            provide: LoginGuestUseCase,
            useFactory: loginGuestUseCaseFactory,
            deps: [UserImplRepository],
        },
        {
            provide: GetUserUseCase,
            useFactory: getUserUseCaseFactory,
            deps: [UserImplRepository],
        },
        {
            provide: UserRepository,
            useClass: UserImplRepository,
        },
    ],
})
export class UserDataModule {}
